import { PatientType } from "types";

const RELATIONS: Record<string, PatientType> = {
  Myself: "self",
  "My Child": "child",
  "My Parent": "parent",
  "Someone Else": "others",
};

const TYPES: Record<string, string> = {
  self: "Myself",
  child: "My Child",
  parent: "My Parent",
};

const transformRelation = (relation: string) => {
  return RELATIONS[relation] || relation;
};

const untransformRelation = (relation: string) => {
  return TYPES[relation] || "Someone Else";
};

export { transformRelation, untransformRelation };
